var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGamelabLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 35.472,
    viewBox: "0 0 180 35.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gamelab-logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(12.724 3.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8536",
    "data-name": "Path 8536",
    d: "M933.136,533.131h6.38c1.646,0,2.123-.483,2.123-2.16v-4.862c0-1.674-.477-2.159-2.123-2.159h-6.38c-1.662,0-2.142.485-2.142,2.159v4.862c0,1.677.48,2.16,2.142,2.16m-.647-7.971h7.673v6.726h-7.673Z",
    transform: "translate(-879.808 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8537",
    "data-name": "Path 8537",
    d: "M954.472,523.95h-7.413v9.181h1.495v-3.593h5.919c1.369,0,1.927-.511,1.927-1.767v-2.055c0-1.253-.558-1.766-1.927-1.766m.414,3.429c0,.829-.359.984-1.022.984h-5.311v-3.258h5.311c.663,0,1.022.157,1.022.987Z",
    transform: "translate(-881.31 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8538",
    "data-name": "Path 8538",
    d: "M969.592,531.9h-7.417v-2.972h4.485v-1.174h-4.485v-2.615h7.344V523.95H960.68v9.18h8.912V531.9",
    transform: "translate(-882.584 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8539",
    "data-name": "Path 8539",
    d: "M975.079,527.718a15.129,15.129,0,0,0-.107-2.016l-.014-.1.052.089a3.534,3.534,0,0,0,.781.9l.146.133,7.089,6.411h.829V523.95h-1.371v5.038a13.191,13.191,0,0,0,.142,2.266l.013.081-.049-.065a8.74,8.74,0,0,0-1.053-1.159l-6.892-6.161h-.935v9.181h1.37v-5.413",
    transform: "translate(-883.802 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8540",
    "data-name": "Path 8540",
    d: "M998.15,527.721h-7.317v-3.77H989.34v9.18h1.493v-4.182h7.317v4.182h1.5v-9.18h-1.5v3.77",
    transform: "translate(-885.263 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8541",
    "data-name": "Path 8541",
    d: "M1013.265,533.131h1.651l-5.107-9.181h-1.62l-5.016,9.181h1.471l1.18-2.271h6.263l1.178,2.271m-6.82-3.409.017-.031,2.5-4.754.017.036,2.5,4.748Z",
    transform: "translate(-886.556 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8542",
    "data-name": "Path 8542",
    d: "M1042.72,531.9H1035.3v-2.972h4.485v-1.174H1035.3v-2.615h7.345V523.95h-8.841v9.18h8.912V531.9",
    transform: "translate(-889.421 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8543",
    "data-name": "Path 8543",
    d: "M1048.208,527.718a14.955,14.955,0,0,0-.108-2.016l-.013-.1.052.089a3.566,3.566,0,0,0,.777.9c.052.046.1.091.148.135l7.09,6.411h.828V523.95h-1.371v5.038a13.1,13.1,0,0,0,.143,2.266l.013.081-.05-.065a8.948,8.948,0,0,0-1.052-1.159l-6.893-6.161h-.935v9.181h1.369v-5.413",
    transform: "translate(-890.639 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8544",
    "data-name": "Path 8544",
    d: "M943.515,541.815l-7.327,12.949h2.934l1.516-2.854h8.309l.012.022,1.555,2.832h3.312l-7.43-12.949h-2.881m-1.635,7.831.034-.062,2.944-5.374.035.069,2.836,5.366Z",
    transform: "translate(-880.294 -525.62)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8545",
    "data-name": "Path 8545",
    d: "M1028.787,541.859l-7.329,12.949h2.933l1.517-2.853h8.308l.012.022,1.554,2.831h3.314l-7.43-12.949h-2.88m-1.637,7.831.035-.062,2.943-5.373.037.068L1033,549.69Z",
    transform: "translate(-888.266 -525.624)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8546",
    "data-name": "Path 8546",
    d: "M966.681,549.722l-.033-.042-6.124-7.866h-2.389v12.949H960.5v-8.015c0-.409-.022-.823-.075-1.385l-.027-.29.108.272a5.718,5.718,0,0,0,.777,1.328l4.887,6.526h.564l4.889-6.5a8.435,8.435,0,0,0,.754-1.356l.107-.224-.027.247a13.792,13.792,0,0,0-.1,1.383v8.015h2.721V541.815h-2.363l-6.031,7.907",
    transform: "translate(-882.346 -525.62)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8547",
    "data-name": "Path 8547",
    d: "M984.677,549.081h6.013v-2.138h-6.013v-2.989h10.306v-2.14H981.73v12.949h13.379V552.4H984.677v-3.315",
    transform: "translate(-884.552 -525.62)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8548",
    "data-name": "Path 8548",
    d: "M1009.247,541.815H1006.3v12.949h12.722V552.4h-9.775V541.815",
    transform: "translate(-886.849 -525.62)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8549",
    "data-name": "Path 8549",
    d: "M1055.289,548.174l-.325-.044.325-.04c1.447-.177,2.212-.922,2.212-2.155v-1.592c0-1.74-.864-2.485-2.887-2.485h-11.123v12.949h10.314c2.554,0,3.8-.82,3.8-2.508v-1.667a2.354,2.354,0,0,0-2.313-2.459m-8.9-4.275h6.962c.906,0,1.43.16,1.43.976v1.236c0,.817-.525.977-1.43.977h-6.962Zm8.468,7.442c0,1.017-.506,1.2-1.506,1.2h-6.962v-3.391h6.962c1.272,0,1.506.406,1.506,1.2Z",
    transform: "translate(-890.326 -525.624)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8550",
    "data-name": "Path 8550",
    d: "M919.239,533.131h7.149c.113,0,.216-.006.314-.013h.038v-1.232h-8.148V525.16h8.148v-1.194h-.007c-.126-.007-.253-.016-.4-.016h-7.1c-1.661,0-2.142.485-2.142,2.159v4.862c0,1.677.481,2.16,2.142,2.16",
    transform: "translate(-878.509 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8551",
    "data-name": "Path 8551",
    d: "M1028.706,530.971v-2.963h-5.23v1.138h3.736v2.74h-7.264V525.16h8.758v-1.2l-.057,0c-.088-.006-.18-.011-.279-.011h-7.774c-1.662,0-2.141.485-2.141,2.159v4.862c0,1.677.479,2.16,2.141,2.16h5.97c1.661,0,2.141-.483,2.141-2.16",
    transform: "translate(-887.985 -523.95)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8552",
    "data-name": "Path 8552",
    d: "M920.18,541.815c-2.476,0-3.192.682-3.192,3.039v6.87c0,2.358.716,3.04,3.192,3.04h8.992c2.476,0,3.192-.682,3.192-3.04V547.27h-7.821v2.14h4.949V552.4h-9.555v-8.341h12.456v-2.241H920.18",
    transform: "translate(-878.499 -525.62)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8553",
    "data-name": "Path 8553",
    d: "M874.529,534.808v9.521h16.437v-3.034H877.532v-6.487h-3",
    transform: "translate(-874.529 -524.965)",
    fill: "#86a498"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8554",
    "data-name": "Path 8554",
    d: "M896.734,527.651H867.577v22.5h29.157v-16.01H880.409v3.034h13.314v9.941H870.578V530.685h26.156v-3.035",
    transform: "translate(-861.155 -521.163)",
    fill: "#86a498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8555",
    "data-name": "Path 8555",
    d: "M860.493,555.966h35.579v-3.035H863.494v-29.4h32.578v-3.034H860.493v35.472",
    transform: "translate(-860.493 -520.494)",
    fill: "#86a498"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelabLogo);
export default __webpack_public_path__ + "static/media/gamelab-logo.835ad5936afca4347c2fc93b0bfa66cc.svg";
export { ForwardRef as ReactComponent };